import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

const paramsSchema = z.object({
  scenarioId: z.coerce.number().int().positive(),
});

export const Route = createFileRoute('/(app)/org/$org/loop/$loopId/planner/scenario/$scenarioId')({
  params: paramsSchema,
});
